/**
 * Footer layout adjustments
 */
(() => {
  const init = () => {
    const footer = document.querySelector('footer.footer');
    if (!footer) return;

    const newsletterContainer = footer.querySelector('.newsletters_container:has(.footer-newsletter)');
    const footerDetailsBottom = footer.querySelector('.footer-details__bottom');
    if (newsletterContainer && footerDetailsBottom) {
      footerDetailsBottom.appendChild(newsletterContainer);
    }

    const nSocial = footer.querySelector('.footer-main .nSocial');
    const footerBot = footer.querySelector('.footer-bot');
    if (nSocial && footerBot) {
      footerBot.appendChild(nSocial);
    }

    const descWrapper = footer.querySelector('.footer-newsletter .desc-wrapper');
    const formWrapper = footer.querySelector('.footer-newsletter .form-wrapper');
    if (descWrapper && formWrapper) {
      const h2 = formWrapper.querySelector('h2');
      if (h2) {
        descWrapper.prepend(h2);
      }
      formWrapper.appendChild(descWrapper);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/**
 * Scroll to top button
 */
(() => {
  const SCROLL_THRESHOLD = 300;

  const init = () => {
    const btn = document.createElement('button');
    btn.className = 'to-top-btn';
    btn.setAttribute('aria-label', 'Scroll to top');
    btn.innerHTML = `<span class="to-top-btn__label">Back to Top</span>
      <svg xmlns="http://www.w3.org/2000/svg" width="83" height="128" viewBox="0 0 83 128" fill="none">
        <path d="M74.0823 123.491C74.0823 93.9083 74.0884 99.3256 74.0792 69.743C74.0792 61.8631 74.0177 53.9801 73.987 46.1002C73.9439 35.7361 66.9587 27.8101 56.6684 26.3528C51.4449 25.6088 46.3658 25.9378 41.6065 28.3451C35.0487 31.6594 31.2332 36.9905 31.1195 44.4185C30.9442 55.7264 30.9688 67.0374 31.1471 78.3454C31.2701 86.2314 37.8157 93.2289 45.1576 93.7916C53.7261 94.4464 60.6376 89.2875 62.2701 80.9341C62.6022 79.2401 62.802 77.4907 62.8112 75.7659C62.8635 66.8099 62.9188 57.8509 62.7774 48.898C62.7436 46.7582 62.3101 44.48 61.4554 42.5277C59.6291 38.3402 55.2173 36.1881 50.8792 36.926C46.6302 37.6515 43.0854 41.4055 42.5535 46.0326C42.2675 48.5137 42.2829 51.0348 42.2737 53.5374C42.2399 60.9592 42.2552 68.381 42.2614 75.8028C42.2614 77.9088 42.4459 78.0779 44.5273 78.084C45.2928 78.084 46.0584 78.084 46.827 78.084C48.7147 78.0882 49.6586 77.1187 49.6586 75.1756C49.6586 66.6808 49.6494 58.1829 49.674 49.6881C49.674 48.6736 49.7631 47.6344 49.9937 46.6505C50.3842 44.9903 51.3803 44.1879 52.7177 44.2463C54.0428 44.3016 55.0943 45.3808 55.3648 46.9795C55.4171 47.2808 55.4571 47.5913 55.454 47.8957C55.4294 58.0784 55.4786 68.2642 55.3372 78.4438C55.2818 82.3791 51.9829 85.9486 48.3519 86.5358C44.4351 87.1661 40.7887 85.0477 39.2669 81.094C38.7811 79.8304 38.4091 78.4284 38.3998 77.0848C38.3291 66.3887 38.2799 55.6895 38.3937 44.9934C38.4429 40.4401 40.595 36.8737 44.7855 34.9521C50.3811 32.388 55.9644 32.5264 61.2955 35.8437C64.7728 38.0082 66.5406 41.1903 66.6789 45.2824C66.7097 46.1525 66.6974 47.0226 66.6974 47.8926C66.6974 122.618 66.7005 49.2842 66.7005 124.01C66.7005 127.216 66.7005 127.238 69.818 127.21C74.6203 127.17 74.0823 127.84 74.0823 122.989C74.0946 85.474 74.0854 125.814 74.0854 120.057L74.0823 123.491Z" fill="#03BCD9"/>
      </svg>`;

    document.body.appendChild(btn);

    btn.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    window.addEventListener('scroll', () => {
      btn.classList.toggle('is-visible', window.scrollY > SCROLL_THRESHOLD);
    }, { passive: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/**
 * Hero banner slider: move pagination bullets out of .ms-container
 * so they position relative to .master-slider (desk/mobile).
 */
(() => {
  const relocateBullets = (banner) => {
    [
      ['.master-slider.deskimg', '.master-slider.deskimg'],
      ['.master-slider.mobileimg', '.master-slider.mobileimg'],
    ].forEach(([sliderSelector, targetSelector]) => {
      const slider = banner.querySelector(sliderSelector);
      const target = banner.querySelector(targetSelector);
      if (!slider || !target) return;

      const bullets = slider.querySelector('.ms-bullets');
      if (bullets && bullets.parentElement !== target) {
        target.appendChild(bullets);
      }
    });
  };

  const init = () => {
    document.querySelectorAll('.hero-banner-slider').forEach(relocateBullets);
  };

  const runWithRetry = () => {
    init();

    let attempts = 0;
    const interval = setInterval(() => {
      init();
      attempts += 1;
      if (attempts >= 20) clearInterval(interval);
    }, 250);
  };

  if (document.readyState === 'complete') {
    runWithRetry();
  } else {
    window.addEventListener('load', runWithRetry);
  }
})();

/**
 * EvoX Banner Slider2
 */
(() => {

})();
